import React from "react";
import { Container, Row } from "react-bootstrap";
import ProjectCard from "./ProjectCards";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading" style={{paddingBottom: "20px"}}>
          <strong>Projects</strong> I've worked on
        </h1>
        <Row style={{padding: "10px" }} class="d-flex justify-content-around">

        <ProjectCard />
          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
